var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import * as keysLib from '@debbie/cortex/dist/api/keys';
import { selectTenantId } from '@debbie/cortex/dist/selectedOwners/selectors';
import powerbiwebconnectPNG from '../assets/images/powerbiwebconnect.png';
import { APIBASE } from '../config';
import { Row, Col } from './Grid';
import { Button, Panel, Modal, Well, CopyToClipboard } from './';
const downloadFile = (content, fileName, contentType) => {
    const bytes = new TextEncoder().encode(content);
    const a = document.createElement('a');
    const file = new Blob([bytes], { type: contentType });
    a.href = URL.createObjectURL(file);
    a.download = fileName;
    a.click();
};
// TODO: Add PBIDS again when more than one data source is suported by Power BI
const getPBIDScontent = (url, key) => {
    return JSON.stringify({
        version: '0.1',
        connections: [
            {
                details: {
                    protocol: 'http',
                    address: {
                        url: `${APIBASE + url}`,
                    },
                    authentication: null,
                    query: null,
                },
                options: {
                    Headers: {
                        Authorization: `Bearer ${key}`,
                        'Content-Type': 'application/json',
                    },
                },
                mode: null,
            },
        ],
    });
};
export var apiTypes;
(function (apiTypes) {
    apiTypes["cases"] = "cases";
    apiTypes["creditors"] = "creditors";
    apiTypes["satisfactions"] = "satisfactions";
    apiTypes["caseVouchers"] = "case-vouchers";
    apiTypes["vouchersBilling"] = "billing-vouchers";
    apiTypes["users"] = "users";
    apiTypes["tasks"] = "updates";
    apiTypes["taskTypes"] = "update-types";
    apiTypes["workflows"] = "workflows";
    apiTypes["workflowTasks"] = "workflow-tasks";
    apiTypes["casesStatusLog"] = "case-statuses";
    apiTypes["interactions"] = "interactions";
    apiTypes["documents"] = "documents";
    apiTypes["paymentPlans"] = "payment-plans";
    apiTypes["paymentPlansEntries"] = "payment-plan-entries";
    apiTypes["customers"] = "customers";
    apiTypes["usersOnCustomers"] = "users-on-customers";
    apiTypes["properties"] = "properties";
})(apiTypes || (apiTypes = {}));
const ApiInsights = (props) => {
    const lang = useSelector((s) => s.lang);
    const tenantId = useSelector(selectTenantId);
    const currentLang = useSelector((s) => s.currentLang);
    const [downloadModal, setDownloadModal] = useState(false);
    const [apiModal, setApiModal] = useState(false);
    const [typeChosen, setTypeChosen] = useState(null);
    const toggleDownloadModal = (type) => {
        setTypeChosen(type);
        setDownloadModal(!downloadModal);
    };
    const toggleApiModal = (type) => {
        setTypeChosen(type);
        setApiModal(!apiModal);
    };
    const standardScope = 'read:insights.';
    const downloadPbids = (type) => __awaiter(void 0, void 0, void 0, function* () {
        const UUID = crypto.randomUUID().substring(0, 8);
        const res = yield keysLib.create({
            name: `powerbi-${type}-${UUID}`,
            scopes: [`${standardScope}${type}`],
        });
        downloadFile(getPBIDScontent(`/v1/${tenantId}/insights/${type.replace(/\./g, '/')}?lang=${currentLang}`, res.key), `${type}-${UUID}.PBIDS`, 'application/json');
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, null,
            !props.isClient && (React.createElement(Col, { width: "3" },
                React.createElement(PanelStyled, { header: lang.users.users },
                    React.createElement("p", null, lang.insights.connectToApi),
                    React.createElement(Button, { size: "small", theme: "secondary", onClick: () => toggleApiModal(apiTypes.users), block: true }, lang.insights.connect)))),
            !props.isClient && (React.createElement(Col, { width: "3" },
                React.createElement(PanelStyled, { header: lang.creditors.creditors },
                    React.createElement("p", null, lang.insights.connectToApi),
                    React.createElement(Button, { size: "small", theme: "secondary", onClick: () => toggleApiModal(apiTypes.creditors), block: true }, lang.insights.connect)))),
            React.createElement(Col, { width: "3" },
                React.createElement(PanelStyled, { header: lang.cases.cases },
                    React.createElement("p", null, lang.insights.connectToApi),
                    React.createElement(Button, { size: "small", theme: "secondary", onClick: () => toggleApiModal(apiTypes.cases), block: true }, lang.insights.connect))),
            !props.isClient && (React.createElement(Col, { width: "3" },
                React.createElement(PanelStyled, { header: lang.caseFilter.satisfactions },
                    React.createElement("p", null, lang.insights.connectToApi),
                    React.createElement(Button, { size: "small", theme: "secondary", onClick: () => toggleApiModal(apiTypes.satisfactions), block: true }, lang.insights.connect)))),
            !props.isClient && (React.createElement(Col, { width: "3" },
                React.createElement(PanelStyled, { header: lang.insights.apiTypes[apiTypes.caseVouchers] },
                    React.createElement("p", null, lang.insights.connectToApi),
                    React.createElement(Button, { size: "small", theme: "secondary", onClick: () => toggleApiModal(apiTypes.caseVouchers), block: true }, lang.insights.connect)))),
            !props.isClient && (React.createElement(Col, { width: "3" },
                React.createElement(PanelStyled, { header: lang.insights.apiTypes[apiTypes.vouchersBilling] },
                    React.createElement("p", null, lang.insights.connectToApi),
                    React.createElement(Button, { size: "small", theme: "secondary", onClick: () => toggleApiModal(apiTypes.vouchersBilling), block: true }, lang.insights.connect)))),
            !props.isClient && (React.createElement(Col, { width: "3" },
                React.createElement(PanelStyled, { header: lang.insights.apiTypes[apiTypes.tasks] },
                    React.createElement("p", null, lang.insights.connectToApi),
                    React.createElement(Button, { size: "small", theme: "secondary", onClick: () => toggleApiModal(apiTypes.tasks), block: true }, lang.insights.connect)))),
            !props.isClient && (React.createElement(Col, { width: "3" },
                React.createElement(PanelStyled, { header: lang.insights.apiTypes[apiTypes.taskTypes] },
                    React.createElement("p", null, lang.insights.connectToApi),
                    React.createElement(Button, { size: "small", theme: "secondary", onClick: () => toggleApiModal(apiTypes.taskTypes), block: true }, lang.insights.connect)))),
            !props.isClient && (React.createElement(Col, { width: "3" },
                React.createElement(PanelStyled, { header: lang.insights.apiTypes[apiTypes.workflows] },
                    React.createElement("p", null, lang.insights.connectToApi),
                    React.createElement(Button, { size: "small", theme: "secondary", onClick: () => toggleApiModal(apiTypes.workflows), block: true }, lang.insights.connect)))),
            !props.isClient && (React.createElement(Col, { width: "3" },
                React.createElement(PanelStyled, { header: lang.insights.apiTypes[apiTypes.workflowTasks] },
                    React.createElement("p", null, lang.insights.connectToApi),
                    React.createElement(Button, { size: "small", theme: "secondary", onClick: () => toggleApiModal(apiTypes.workflowTasks), block: true }, lang.insights.connect)))),
            !props.isClient && (React.createElement(Col, { width: "3" },
                React.createElement(PanelStyled, { header: lang.insights.apiTypes[apiTypes.casesStatusLog] },
                    React.createElement("p", null, lang.insights.connectToApi),
                    React.createElement(Button, { size: "small", theme: "secondary", onClick: () => toggleApiModal(apiTypes.casesStatusLog), block: true }, lang.insights.connect)))),
            !props.isClient && (React.createElement(Col, { width: "3" },
                React.createElement(PanelStyled, { header: lang.insights.apiTypes[apiTypes.interactions] },
                    React.createElement("p", null, lang.insights.connectToApi),
                    React.createElement(Button, { size: "small", theme: "secondary", onClick: () => toggleApiModal(apiTypes.interactions), block: true }, lang.insights.connect)))),
            !props.isClient && (React.createElement(Col, { width: "3" },
                React.createElement(PanelStyled, { header: lang.insights.apiTypes[apiTypes.documents] },
                    React.createElement("p", null, lang.insights.connectToApi),
                    React.createElement(Button, { size: "small", theme: "secondary", onClick: () => toggleApiModal(apiTypes.documents), block: true }, lang.insights.connect)))),
            !props.isClient && (React.createElement(Col, { width: "3" },
                React.createElement(PanelStyled, { header: lang.insights.apiTypes[apiTypes.paymentPlans] },
                    React.createElement("p", null, lang.insights.connectToApi),
                    React.createElement(Button, { size: "small", theme: "secondary", onClick: () => toggleApiModal(apiTypes.paymentPlans), block: true }, lang.insights.connect)))),
            !props.isClient && (React.createElement(Col, { width: "3" },
                React.createElement(PanelStyled, { header: lang.insights.apiTypes[apiTypes.paymentPlansEntries] },
                    React.createElement("p", null, lang.insights.connectToApi),
                    React.createElement(Button, { size: "small", theme: "secondary", onClick: () => toggleApiModal(apiTypes.paymentPlansEntries), block: true }, lang.insights.connect)))),
            !props.isClient && (React.createElement(Col, { width: "3" },
                React.createElement(PanelStyled, { header: lang.insights.apiTypes[apiTypes.customers] },
                    React.createElement("p", null, lang.insights.connectToApi),
                    React.createElement(Button, { size: "small", theme: "secondary", onClick: () => toggleApiModal(apiTypes.customers), block: true }, lang.insights.connect)))),
            !props.isClient && (React.createElement(Col, { width: "3" },
                React.createElement(PanelStyled, { header: lang.insights.apiTypes[apiTypes.usersOnCustomers] },
                    React.createElement("p", null, lang.insights.connectToApi),
                    React.createElement(Button, { size: "small", theme: "secondary", onClick: () => toggleApiModal(apiTypes.usersOnCustomers), block: true }, lang.insights.connect)))),
            !props.isClient && (React.createElement(Col, { width: "3" },
                React.createElement(PanelStyled, { header: lang.insights.apiTypes[apiTypes.properties] },
                    React.createElement("p", null, lang.insights.connectToApi),
                    React.createElement(Button, { size: "small", theme: "secondary", onClick: () => toggleApiModal(apiTypes.properties), block: true }, lang.insights.connect)))),
            downloadModal && (React.createElement(Modal, { onToggle: () => toggleDownloadModal(null), header: lang.insights.download +
                    ' ' +
                    (typeChosen
                        ? lang.insights.apiTypes[typeChosen] || typeChosen
                        : typeChosen), maxWidth: "350px" },
                React.createElement("p", null, lang.insights.downloadLimit),
                React.createElement(Button, { size: "small", theme: "secondary", onClick: () => __awaiter(void 0, void 0, void 0, function* () { return typeChosen && (yield downloadPbids(typeChosen)); }), block: true }, lang.insights.download))),
            apiModal && (React.createElement(Modal, { onToggle: () => toggleApiModal(null), header: lang.insights.connect +
                    ' ' +
                    (typeChosen
                        ? lang.insights.apiTypes[typeChosen] || typeChosen
                        : typeChosen), maxWidth: "550px" },
                React.createElement("p", null, lang.insights.connectGuide.description),
                React.createElement("p", null, lang.insights.downloadLimit),
                React.createElement(Contents, null,
                    React.createElement("ol", null,
                        React.createElement("li", null, lang.insights.connectGuide.liIntroStep1),
                        React.createElement("li", null, lang.insights.connectGuide.liIntroStep2),
                        React.createElement("li", null, lang.insights.connectGuide.liIntroStep3),
                        React.createElement("li", null,
                            lang.insights.connectGuide.liIntroStep4,
                            React.createElement("br", null),
                            React.createElement("br", null),
                            React.createElement(Well, null,
                                React.createElement("b", null,
                                    standardScope,
                                    typeChosen))),
                        React.createElement("li", null,
                            lang.insights.connectGuide.liIntroStep5,
                            ":",
                            React.createElement("br", null),
                            React.createElement("br", null),
                            typeChosen && (React.createElement(Well, null,
                                React.createElement("b", null,
                                    React.createElement(CopyToClipboard, null, APIBASE +
                                        `/v1/${tenantId}/insights/${typeChosen.replace(/\./g, '/')}?lang=${currentLang}${props.creditorId
                                            ? `&creditorId=${props.creditorId}`
                                            : ''}`)))))),
                    React.createElement("p", null, lang.insights.connectGuide.powerbiDescription),
                    React.createElement("ol", null,
                        React.createElement("li", null, lang.insights.connectGuide.liPowerbiStep1),
                        React.createElement("li", null,
                            lang.insights.connectGuide.liPowerbiStep2,
                            " ",
                            `<your URL>`,
                            ' ',
                            lang.insights.connectGuide.liPowerbiStep3,
                            " ",
                            `<your token>`,
                            ' ',
                            lang.insights.connectGuide.liPowerbiStep4),
                        React.createElement("li", null, lang.insights.connectGuide.liPowerbiStep5))),
                React.createElement("img", { width: "100%", src: powerbiwebconnectPNG, style: {
                        margin: '0 auto',
                        display: 'block',
                    } }),
                React.createElement(Button, { block: true, onClick: () => toggleApiModal(null) }, lang.insights.connectGuide.understood))))));
};
export default ApiInsights;
const PanelStyled = styled(Panel) `
  .body > p {
    min-height: 80px;
    margin-top: 8px;
  }
`;
const Contents = styled.div `
  ol {
    text-align: left;
    margin: 0;

    li {
      margin: 7px 0;
    }
  }
`;
//# sourceMappingURL=ApiInsights.js.map